import React, { Component, Fragment } from 'react'
import * as R from 'ramda'
import PropTypes from 'prop-types'
import BurgerButton from '@components/BurgerButton'
import MobileDropdown from '@components/MobileDropdown'
import PrimaryNavigation from '@components/PrimaryNavigation'
import SecondaryNav from '@components/SecondaryNav'

import ModalSearch from '@components/ModalSearch'
import { ReactComponent as Search } from '@assets/svgs/icons/search.svg'
import classnames from 'classnames'
import { LocationShape } from '@types/types'
import 'lazysizes'
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import './Header.module.scss'
import HeaderLogo from '@components/HeaderLogo'

class Header extends Component {
  state = {
    menuToggle: false,
    search: false
  }

  logoClick = () => {
    this.setState({ menuToggle: false })
  }

  toggleMenu = () => {
    this.setState((prevState) => ({ menuToggle: !prevState.menuToggle }))
  }

  openModalSearch = () => this.setState({ search: true })

  closeModalSearch = (e) => {
    e.stopPropagation()
    this.setState({
      search: false,
      menuToggle: e.target.nodeName === 'svg'
    })
  }

  render () {
    const { links, siteSearchData, location } = this.props
    const { menuToggle, search } = this.state

    return (
      <Fragment>
        <header styleName='header'>
          <div styleName='background' />
          <section styleName='logo-nav-block'>
            <HeaderLogo />
            {R.not(R.isEmpty(links)) && <PrimaryNavigation links={links} location={location} allowSubmenu />}
            {siteSearchData && (
              <span
                styleName={classnames('search-icon-wrap', {
                  'search-icon-show': menuToggle
                })}
                onClick={this.openModalSearch}
              >
                <Search styleName='search-icon' />
                <span styleName='search-box-container'>
                  <Search styleName='search-icon' />
                  <span>SEARCH...</span>
                </span>
              </span>
            )}
            {R.and(siteSearchData, search) && (
              <ModalSearch close={this.closeModalSearch} data={siteSearchData} location={location} />
            )}
          </section>
          <section styleName='icon-link-block'>
            <SecondaryNav />
          </section>
          <BurgerButton menuToggle={menuToggle} click={this.toggleMenu} />
        </header>
        <MobileDropdown links={links} menuToggle={menuToggle} click={this.toggleMenu} allowSubmenu />
      </Fragment>
    )
  }
}

Header.propTypes = {
  links: PropTypes.arrayOf(PropTypes.string).isRequired,
  siteSearchData: PropTypes.object.isRequired,
  location: LocationShape.isRequired
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.js